module.exports = __webpack_public_path__ + "img/feature-icon-2.e4cb7fd5.svg";